export interface IAppEvent{
	name: string; // event name
	target?: string; // the target of event
	extra?: any; // custom payload
}

export interface ISocketEvent{
	channel: string;
	data: ISocketData;
	event: string;
}

interface ISocketData{
	datasetCode: string;
	eventName: string;
	payloadData: any;
	requestId: any;
	socket: any;
	workDomainId: any;
}

export enum AppEventNames{}
